import React from 'react'

const SidebarDashboardIcon = ({ isActive }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4444 9.88889V16.5556M11 5.44444V16.5556M6.55556 12.1111V16.5556M11 21C6.83363 21 4.75045 21 3.29008 19.939C2.81844 19.5963 2.40368 19.1816 2.06102 18.7099C1 17.2496 1 15.1664 1 11C1 6.83363 1 4.75045 2.06102 3.29008C2.40368 2.81844 2.81844 2.40368 3.29008 2.06102C4.75045 1 6.83363 1 11 1C15.1664 1 17.2496 1 18.7099 2.06102C19.1816 2.40368 19.5963 2.81844 19.939 3.29008C21 4.75045 21 6.83363 21 11C21 15.1664 21 17.2496 19.939 18.7099C19.5963 19.1816 19.1816 19.5963 18.7099 19.939C17.2496 21 15.1664 21 11 21Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default SidebarDashboardIcon
